module.exports = __webpack_public_path__ + "static/media/challenge-popup-header.148d3085.png";